import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { Container, Bubble, Pointer } from "./styles";

let SpeechBubble = ({ show = false, className, children }) => {
    return (
        <Container className={className} opacity={show ? 1 : 0}>
            <Bubble>{children}</Bubble>
            <Pointer />
        </Container>
    );
};

SpeechBubble = styled(SpeechBubble)``;

SpeechBubble.propTypes = {
    show: PropTypes.bool
};

export default SpeechBubble;
